export const DATE_FORMATS = {
    INPUT: 'DD.MM.YYYY, HH:mm:ss.SSS',
    INPUT_NO_SECONDS: 'DD.MM.YYYY, HH:mm',
    DISPLAY_SHORT: 'MMM DD, HH:mm:ss',
    DISPLAY_SHORT_NO_SECONDS: 'MMM DD, HH:mm',
    DISPLAY_LONG: 'MMM DD, YYYY HH:mm:ss',
    DISPLAY_LONG_NO_SECONDS: 'MMM DD, YYYY HH:mm',
    DISPLAY_WITH_YEAR: 'MMM DD, YYYY',
    DISPLAY_SHORT_DATE: 'MMM DD',
    ISO: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
};
export const DISPLAY_DATE_FORMATS = {
    withSeconds: { currentYear: DATE_FORMATS.DISPLAY_SHORT, otherYear: DATE_FORMATS.DISPLAY_LONG },
    noSeconds: { currentYear: DATE_FORMATS.DISPLAY_SHORT_NO_SECONDS, otherYear: DATE_FORMATS.DISPLAY_LONG_NO_SECONDS },
};
export const TIME_FORMATS = {
    TIME_ONLY: 'HH:mm:ss',
    TIME_SHORT: 'HH:mm',
};
export const DATETIME_FORMATS = {
    FULL: 'DD.MM.YYYY, HH:mm:ss.SSS',
    STANDARD: 'MMM DD, YYYY @ HH:mm:ss',
    STANDARD_NO_MS: 'MMM DD, YYYY @ HH:mm:ss',
    DASHED: 'MMM-DD-YYYY HH:mm:ss',
    DASHED_DATE_ONLY: 'MMM-DD-YYYY',
    WITH_AMPM: 'MMM DD, YYYY, h:mm A',
};
export const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const UTC_TIMEZONE = 'UTC';
//# sourceMappingURL=constants.js.map